import { render, staticRenderFns } from "./ContractItem.vue?vue&type=template&id=2fa9e8d8&scoped=true&"
import script from "./ContractItem.vue?vue&type=script&lang=js&"
export * from "./ContractItem.vue?vue&type=script&lang=js&"
import style0 from "./ContractItem.vue?vue&type=style&index=0&id=2fa9e8d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa9e8d8",
  null
  
)

export default component.exports